import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import { connect } from 'react-redux';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { Lock, LockOpen } from '@material-ui/icons';

@connect(state => ({
  mks: state.mks,
}))
class MksCylinderDetailsView extends React.Component {

  render() {
    const { cylinderData, onRequestCylinderDuplication } = this.props;
    const associatedKeys = cylinderData.associatedKeys || [];

    return (
      <div style={{ paddingBottom: 100 }}>
        <FormFlatContainer
          title="cylinderDetails"
          icon={<LockOpen style={{ fontSize: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 0 }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="id" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.id || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="externalId" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.externalId || '---'}</h4>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="doorName" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.doorName || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="marking" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.marking || '---'}</h4>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="type" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.type || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="quantity" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.quantity || '---'}</h4>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="insideLength" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.insideLength || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="outsideLength" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.outsideLength || '---'}</h4>
              </div>
            </div>

            {cylinderData.change || cylinderData.family ? (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ flex: 1 }}>
                  <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                    <Entity entity="change" />
                  </h5>
                  <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.change || '---'}</h4>
                </div>
                <div style={{ flex: 1 }}>
                  <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                    <Entity entity="family" />
                  </h5>
                  <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{cylinderData.family || '---'}</h4>
                </div>
              </div>
            ) : null}
            <MDButton
              title={<Entity entity="requestCylinderDuplication" />}
              onClick={() => onRequestCylinderDuplication && onRequestCylinderDuplication(cylinderData)}
              containerStyle={{ width: '90%', margin: 'auto', marginTop: 5 }}
            />
          </div>
        </FormFlatContainer>

        <FormFlatContainer
          title="associatedKeys"
          subtitle="associatedKeysSubtitle"
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(associatedKeys) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="externalId" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="keyFunction" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="designation" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="quantity" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ maxHeight: 200, overflowY: 'auto', backgroundColor: 'white' }}>
                {_.map(associatedKeys, (key) => (
                  <TableRow key={key.keyId || key.id}>
                    <TableCell><h5 style={{ margin: 0 }}>{key.keyExternalId || key.externalId || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{key.keyFunction || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{key.keyDesignation || key.designation || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{key.keyQuantity || key.quantity || '---'}</h5></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noAssociatedKeys" /></h5>
            </div>
          )}
        </FormFlatContainer>
      </div>
    );
  }
}

export default MksCylinderDetailsView;

